export default "__VITE_ASSET__DpzsHkVZ__"